import { AdminType } from "@resamare/models";
import {
    BoatIcon,
    BottomNavigation,
    CalendarUnavailabilityIcon,
    CheckListIcon,
    FullPageSpinner,
    LogoutIcon,
    ScanQrCodeIcon,
} from "@resamare/ui";
import { useAdmin, useGetConfig } from "@resamare/widgets-shared";
import { ActivityTypeEnum, useGetActivityTypes } from "@/features/activityTypes";

function Navigation() {
    const configQuery = useGetConfig();
    const { admin } = useAdmin();
    const activityTypesQuery = useGetActivityTypes();

    if (activityTypesQuery.isPending || configQuery.isPending) return <FullPageSpinner />;
    if (!activityTypesQuery.data || !configQuery.data) return null;

    const hasLocation = activityTypesQuery.data.some(
        (type) => type.titre === ActivityTypeEnum.LOCATION,
    );

    const isInstructor = admin.admin_type_id === AdminType.INSTRUCTOR;
    const config = configQuery.data;

    const menuItems = [
        ...(config.mode_scan === "global"
            ? [
                  {
                      icon: <ScanQrCodeIcon />,
                      label: "Scan",
                      to: "/scan",
                  },
              ]
            : [
                  {
                      icon: <CheckListIcon />,
                      label: "Sessions",
                      to: "/sessions",
                  },
              ]),

        ...(hasLocation
            ? [
                  {
                      icon: <BoatIcon />,
                      label: "Locations",
                      to: "/locations",
                  },
              ]
            : []),
        ...(isInstructor
            ? [
                  {
                      icon: <CalendarUnavailabilityIcon />,
                      label: "Indisponibilités",
                      to: "/unavailabilities",
                  },
              ]
            : []),
        {
            icon: <LogoutIcon />,
            label: "Déconnexion",
            to: "/auth/logout",
        },
    ];

    return <BottomNavigation items={menuItems} />;
}

export default Navigation;
